import { useState, useEffect } from "react";
import { subirDatos, bajarDatos, eliminarDato } from "./syncSupabase";
import BotonMapaProceso from "./BotonMapaProceso";

const STORAGE_KEY = 'alqos_centros_costo';

const TIPOS_MAQUINA = ['impresion','corte','terminacion','plegado','troquelado','otro'];
const TIPOS_MATERIAL = ['cartulina','papel','tinta','barniz','adhesivo','plastico','otro'];

const MAQUINA_VACIA = {
  tipoRegistro: 'maquina',
  nombre: '', tipo: 'impresion', costoHora: '',
  velocidad: '', unidadVelocidad: '',
  setupMinutos: '', mermaArranqueUnidades: '',
};

const MATERIAL_VACIO = {
  tipoRegistro: 'material',
  nombre: '', tipo: 'cartulina', costoKg: '',
  rendimientoUnidadPorKg: '', unidadRendimiento: '',
  mermaProcesoPct: '',
};

const storage = {
  get: () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } },
};

export default function CentrosCosto({ onVolver, oscuro, usuario }) {
  const [registros, setRegistros] = useState(() => storage.get());
  const [tab, setTab] = useState('maquinas');
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formMaq, setFormMaq] = useState(MAQUINA_VACIA);
  const [formMat, setFormMat] = useState(MATERIAL_VACIO);

  useEffect(() => {
    bajarDatos(STORAGE_KEY).then(huboDatos => {
      if (huboDatos) setRegistros(storage.get());
    });
    const onSync = () => setRegistros(storage.get());
    window.addEventListener('supabase-sync-complete', onSync);
    return () => window.removeEventListener('supabase-sync-complete', onSync);
  }, []);

  const guardar = (lista) => {
    setRegistros(lista);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
    subirDatos(STORAGE_KEY);
  };

  const maquinas = registros.filter(r => r.tipoRegistro === 'maquina');
  const materiales = registros.filter(r => r.tipoRegistro === 'material');

  const abrirNuevo = () => {
    setEditando(null);
    setFormMaq(MAQUINA_VACIA);
    setFormMat(MATERIAL_VACIO);
    setShowForm(true);
  };

  const abrirEditar = (item) => {
    setEditando(item);
    if (item.tipoRegistro === 'maquina') setFormMaq({ ...MAQUINA_VACIA, ...item });
    else setFormMat({ ...MATERIAL_VACIO, ...item });
    setShowForm(true);
  };

  const guardarItem = () => {
    const esMaquina = tab === 'maquinas';
    const form = esMaquina ? formMaq : formMat;
    if (!form.nombre.trim()) return alert('El nombre es obligatorio');

    if (editando) {
      const lista = registros.map(r => r.id === editando.id ? { ...form, id: editando.id } : r);
      guardar(lista);
    } else {
      const nuevo = { ...form, id: Math.floor(Date.now()) };
      guardar([nuevo, ...registros]);
    }
    setShowForm(false);
    setEditando(null);
    setFormMaq(MAQUINA_VACIA);
    setFormMat(MATERIAL_VACIO);
  };

  const eliminarItem = async (id) => {
    if (!window.confirm('¿Eliminar este registro?')) return;
    const lista = registros.filter(r => r.id !== id);
    setRegistros(lista);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
    await eliminarDato(STORAGE_KEY, id);
  };

  const setM = (k, v) => setFormMaq(f => ({ ...f, [k]: v }));
  const setT = (k, v) => setFormMat(f => ({ ...f, [k]: v }));

  const inp = { width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif' };
  const lbl = { fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' };

  const TabBtn = ({ id, label }) => (
    <button onClick={() => setTab(id)} style={{ padding: '7px 16px', borderRadius: '8px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: tab === id ? '#1C3FAA' : 'transparent', color: tab === id ? 'white' : '#6B7280' }}>{label}</button>
  );

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button onClick={onVolver} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', color: '#6B7280' }}>← Menú</button>
            <span style={{ fontSize: '22px' }}>⚙️</span>
            <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Centros de Costo</h1>
            {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="centros_costo" oscuro={oscuro} />}
          </div>
          <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px', marginLeft: '32px' }}>Máquinas y materiales · fuente única para Costos de No Calidad y Motor de Costeo</p>
        </div>
        <button onClick={abrirNuevo} style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '10px', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
          + {tab === 'maquinas' ? 'Nueva máquina' : 'Nuevo material'}
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '4px', background: 'white', padding: '4px', borderRadius: '10px', border: '1px solid #E5E7EB', width: 'fit-content', marginBottom: '20px' }}>
        <TabBtn id="maquinas" label={`⚙️ Máquinas (${maquinas.length})`} />
        <TabBtn id="materiales" label={`📦 Materiales (${materiales.length})`} />
      </div>

      {/* Tabla Máquinas */}
      {tab === 'maquinas' && (
        <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
          {maquinas.length === 0 ? (
            <div style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>⚙️</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>Sin máquinas cargadas</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Nombre', 'Tipo', '$/hora', 'Velocidad', 'Setup (min)', 'Merma arranque', ''].map(h => (
                    <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {maquinas.map(m => (
                  <tr key={m.id} onClick={() => abrirEditar(m)} style={{ cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontWeight: '600', fontSize: '13px', color: '#111827' }}>{m.nombre}</td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                      <span style={{ background: '#E8E9F6', color: '#1C3FAA', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{m.tipo}</span>
                    </td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.costoHora ? `$${m.costoHora}` : '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.velocidad ? `${m.velocidad} ${m.unidadVelocidad || ''}` : '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.setupMinutos || '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.mermaArranqueUnidades || '—'}</td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }} onClick={e => e.stopPropagation()}>
                      <button onClick={() => eliminarItem(m.id)} style={{ background: 'none', border: '1px solid #fee2e2', color: '#dc2626', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tabla Materiales */}
      {tab === 'materiales' && (
        <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
          {materiales.length === 0 ? (
            <div style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>📦</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>Sin materiales cargados</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Nombre', 'Tipo', '$/kg', 'Rendimiento', 'Merma proceso', ''].map(h => (
                    <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {materiales.map(m => (
                  <tr key={m.id} onClick={() => abrirEditar(m)} style={{ cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontWeight: '600', fontSize: '13px', color: '#111827' }}>{m.nombre}</td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                      <span style={{ background: '#E8E9F6', color: '#1C3FAA', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{m.tipo}</span>
                    </td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.costoKg ? `$${m.costoKg}` : '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.rendimientoUnidadPorKg ? `${m.rendimientoUnidadPorKg} ${m.unidadRendimiento || ''}` : '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{m.mermaProcesoPct ? `${m.mermaProcesoPct}%` : '—'}</td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }} onClick={e => e.stopPropagation()}>
                      <button onClick={() => eliminarItem(m.id)} style={{ background: 'none', border: '1px solid #fee2e2', color: '#dc2626', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Modal form */}
      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '480px', maxHeight: '92vh', overflowY: 'auto', padding: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>
                {editando ? '✏️ Editar' : '+ Nuevo'} {tab === 'maquinas' ? 'máquina' : 'material'}
              </h2>
              <button onClick={() => setShowForm(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
            </div>

            {tab === 'maquinas' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={lbl}>Nombre *</label>
                  <input style={inp} placeholder="Ej: Offset UV 1" value={formMaq.nombre} onChange={e => setM('nombre', e.target.value)} />
                </div>
                <div>
                  <label style={lbl}>Tipo</label>
                  <select style={inp} value={formMaq.tipo} onChange={e => setM('tipo', e.target.value)}>
                    {TIPOS_MAQUINA.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Costo por hora ($)</label>
                  <input style={inp} type="number" placeholder="Ej: 5500" value={formMaq.costoHora} onChange={e => setM('costoHora', e.target.value)} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={lbl}>Velocidad</label>
                    <input style={inp} type="number" placeholder="Ej: 4500" value={formMaq.velocidad} onChange={e => setM('velocidad', e.target.value)} />
                  </div>
                  <div>
                    <label style={lbl}>Unidad velocidad</label>
                    <input style={inp} placeholder="Ej: pliegos/hora" value={formMaq.unidadVelocidad} onChange={e => setM('unidadVelocidad', e.target.value)} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={lbl}>Setup (minutos)</label>
                    <input style={inp} type="number" placeholder="Ej: 45" value={formMaq.setupMinutos} onChange={e => setM('setupMinutos', e.target.value)} />
                  </div>
                  <div>
                    <label style={lbl}>Merma arranque (unidades)</label>
                    <input style={inp} type="number" placeholder="Ej: 200" value={formMaq.mermaArranqueUnidades} onChange={e => setM('mermaArranqueUnidades', e.target.value)} />
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={lbl}>Nombre *</label>
                  <input style={inp} placeholder="Ej: Cartulina SBS 300g" value={formMat.nombre} onChange={e => setT('nombre', e.target.value)} />
                </div>
                <div>
                  <label style={lbl}>Tipo</label>
                  <select style={inp} value={formMat.tipo} onChange={e => setT('tipo', e.target.value)}>
                    {TIPOS_MATERIAL.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Costo por kg ($)</label>
                  <input style={inp} type="number" placeholder="Ej: 1200" value={formMat.costoKg} onChange={e => setT('costoKg', e.target.value)} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={lbl}>Rendimiento por kg</label>
                    <input style={inp} type="number" placeholder="Ej: 2.8" value={formMat.rendimientoUnidadPorKg} onChange={e => setT('rendimientoUnidadPorKg', e.target.value)} />
                  </div>
                  <div>
                    <label style={lbl}>Unidad rendimiento</label>
                    <input style={inp} placeholder="Ej: pliegos/kg" value={formMat.unidadRendimiento} onChange={e => setT('unidadRendimiento', e.target.value)} />
                  </div>
                </div>
                <div>
                  <label style={lbl}>Merma de proceso (%)</label>
                  <input style={inp} type="number" placeholder="Ej: 5" value={formMat.mermaProcesoPct} onChange={e => setT('mermaProcesoPct', e.target.value)} />
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setShowForm(false)} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>Cancelar</button>
              <button onClick={guardarItem} style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#1C3FAA', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
